<script lang="ts">
  import Link from "svelte-link";
  import FeatherIcon from "svelte-feather-icon";
  import { Badge, Image } from "sveltestrap";
  import { Experince, Follow, Follower, href, News } from "../../utils/Constant/Constant";
  let imgPath : string= '/assets/images/dashboard';
</script>
<div class="sidebar-user text-center">
    <Link class="setting-primary" href={href}>
      <FeatherIcon icon="settings" />
    </Link>
    <Image  
      class="img-90 rounded-circle"
      src="{imgPath}/1.png"
      alt=""
    />
    <div class="badge-bottom">
      <Badge color="primary">{News}</Badge>
    </div>
    <Link href={href}>
      <h6 class="mt-3 f-14 f-w-600">Emay Walter</h6>
    </Link>
    <p class="mb-0 font-roboto">Human Resources Department</p>
    <ul>
      <li>
        <span><span class="counter">19.8</span>k</span>
        <p>{Follow}</p>
      </li>
      <li>
        <span>2 year</span>
        <p>{Experince}</p>
      </li>
      <li>
        <span><span class="counter">95.2</span>k</span>
        <p>{Follower}</p>
      </li>
    </ul>
</div>